import { IDatiqDownload } from './datiq-download.interface';
import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_STRING,
} from '@dat/datiq-core/models';

export const DATIQ_FILE_DOWNLOAD_ID: string = 'datiq-file-download-rfp-add';

export const emptyDatiqDownload: IDatiqDownload = {
    id: DATIQ_DEFAULT_ID(),
    title: DATIQ_DEFAULT_EMPTY_LABEL,
    filepath: DATIQ_DEFAULT_STRING,
};
